import { default as ALSProvider } from './als';
import { default as DataFactory } from './data';
import { default as configurationProvider } from './configurationProvider';
var defaultAls = function (app) {
    return new ALSProvider(new DataFactory().withProvider(configurationProvider(app)));
};
var ALS = {
    default: defaultAls,
    ALSProvider: ALSProvider,
    DataFactory: DataFactory,
    configurationProvider: configurationProvider,
};
export default ALS;
//# sourceMappingURL=index.js.map